// extracted by mini-css-extract-plugin
export default {"root":"UpdateLogManage_root__Sdp87"};